import LazyLoad from 'vanilla-lazyload';

const doLazy = () => {

	let lazyLoadInstance = new LazyLoad({
		elements_selector: 'img.lazyload',
		use_native: true,
		threshold: 100,
	});

	setTimeout(function () {
		lazyLoadInstance.update();
	}, 1500);
}

export default doLazy;
